module.exports = __webpack_public_path__ + "assets/Angle54.1526d735d581a912bb0fb440e4debfad.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Angle54.gmt
// module id = 895
// module chunks = 0